import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Card             from '@material-ui/core/Card'
import CardContent      from '@material-ui/core/CardContent'
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid             from '@material-ui/core/Grid'
import IconButton       from '@material-ui/core/IconButton'
import Tooltip          from '@material-ui/core/Tooltip'

import { Resource as TResource }     from '../../api'
import { canUploadProcessResources } from '../../project-utils/permissions'
import { Communication }             from '../../redux'
import { PermissionGuard }           from '../atoms'
import loadable                      from '../hocs/loadable'
import { Resource }                  from '../molecules'

interface ResourceListProps extends Communication {
  resources: TResource []
  onUpload: (e: any) => void
}

const ResourceList = loadable(({ resources }: any) =>
  resources && resources.filter(Boolean).map(resource => (
    <Grid
      item
      key={resource.url}
      xs={12}
      sm={6}
      md={4}
      lg={3}
    >
      <Resource {...resource} />
    </Grid>
  )))

const Resources = ({ onUpload, fetching, ...rest }: ResourceListProps) => (
  <Grid container spacing={16} alignItems={'stretch'}>
    <PermissionGuard check={canUploadProcessResources}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <Card className={'stretch-vertical'}>
          <CardContent className={'stretch-vertical'}>
            <Grid
              container
              alignItems={'center'}
              justify={'center'}
              className={'stretch-vertical'}
            >
              <Grid item>
                <input
                  onChange={onUpload}
                  id={'file-input'}
                  name={'file-input'}
                  type={'file'}
                  hidden
                />
                <label htmlFor={'file-input'}>
                  {fetching
                    ? <CircularProgress />
                    : (
                      <Tooltip
                        placement={'bottom'}
                        title={<FormattedMessage id={'tooltip.uploadFile'} />}
                      >
                        <IconButton component={'span'}>
                          <img 
                            style={{ width: '35px' }} 
                            src={'/assets/subir-archivo.svg'} 
                            alt='upload' 
                          />
                        </IconButton>
                      </Tooltip>
                    )
                  }
                </label>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <ResourceList isCached {...rest} />
    </PermissionGuard>
  </Grid>
)

export default Resources



// WEBPACK FOOTER //
// ./src/components/organisms/Resources.tsx